import React, { useEffect, useState } from 'react';
import { LegalLayout } from './LegalLayout';
import { Plus, Minus } from 'lucide-react';
import api from '../../lib/api';

const FALLBACK = [
  { id: 'f1', question: "Quels types d'événements organisez-vous ?", answer: "JBMH Event accompagne les célébrations privées et événements prestige." },
];

const Item = ({ q, a, open, onClick }) => (
  <div className="border-b border-[#111111]/15" data-testid="faq-item">
    <button onClick={onClick} className="w-full py-7 flex justify-between items-center text-left gap-6">
      <span className="font-serif text-xl text-[#111111]">{q}</span>
      <span className="shrink-0 text-[#111111]">{open ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}</span>
    </button>
    {open && <div className="pb-8 pr-12 text-[#333333] font-light leading-relaxed whitespace-pre-wrap">{a}</div>}
  </div>
);

const FAQ = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get('/faqs')
      .then(({ data }) => setItems(data.length > 0 ? data : FALLBACK))
      .catch(() => setItems(FALLBACK));
  }, []);

  return (
    <LegalLayout kicker="Vos questions" title="FAQ">
      <div className="not-prose">
        {items.map((f, i) => (
          <Item key={f.id || i} q={f.question} a={f.answer} open={open === i} onClick={() => setOpen(open === i ? -1 : i)} />
        ))}
      </div>
    </LegalLayout>
  );
};

export default FAQ;
